export default __webpack_public_path__ + "static/media/tumble-dryer-gray.bdd515b0.svg";